function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1ABCFE",
  d: "M39.5 39.5c0-7.364 5.932-13.333 13.25-13.333S66 32.137 66 39.5c0 7.364-5.932 13.333-13.25 13.333S39.5 46.863 39.5 39.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0ACF83",
  d: "M13 66.167c0-7.364 5.932-13.334 13.25-13.334H39.5v13.334c0 7.363-5.932 13.333-13.25 13.333S13 73.53 13 66.167z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF7262",
  d: "M39.5-.5v26.667h13.25c7.318 0 13.25-5.97 13.25-13.334C66 5.47 60.068-.5 52.75-.5H39.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F24E1E",
  d: "M13 12.833c0 7.364 5.932 13.334 13.25 13.334H39.5V-.5H26.25C18.932-.5 13 5.47 13 12.833z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A259FF",
  d: "M13 39.5c0 7.364 5.932 13.333 13.25 13.333H39.5V26.167H26.25C18.932 26.167 13 32.137 13 39.5z"
}));

var SvgFigmaIco = function SvgFigmaIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFigmaIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/figma_ico.41497acb.svg";
export { ForwardRef as ReactComponent };